import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    error: '',
    isLoading: false,
    items: [],
    view: [],
    userDataOptions: [],
    itemOptions: []
  },
  getters: {
    error: (state) => state.error,
    isLoading: (state) => state.isLoading,
    items: (state) => state.items,
    view: (state) => state.view
  },
  mutations: {
    setError (state, error) {
      state.error = error
    },
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setItems (state, items) {
      state.items = items
    },
    setView (state, view) {
      state.view = view
    }
  },
  actions: {
    async getItems ({ commit }, url = 'e_x_a_b_external_forms') {
      commit('toggleLoading')
      const response = await new ApiService(url).getResults()
      commit('setItems', await response.items)
      commit('setView', await response.view)
      commit('toggleLoading')
    }
  }
}
